const Index = () => import('./index.vue');
const QuickAudit = () => import('./quick-audit.vue');
const ResetStock = () => import('./reset-stock.vue');
const ResetBranchStock = () => import('./reset-branch-stock.vue');

export default [
    {
        path: '/inventory',
        component: Index
    },
    {
        path: '/quick-audit/:id',
        component: QuickAudit
    },
    {
        path: '/reset-stock',
        component: ResetStock
    },
    {
        path: '/reset-branch-stock',
        component: ResetBranchStock
    }
];